import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import ModuleContent from '../components/Sections/ModuleContent';
import './Features.css';

const FeaturesPage = () => {
  const location = useLocation();
  const [activeModule, setActiveModule] = useState('satis');

  useEffect(() => {
    // URL hash'inden modülü belirle
    const hash = location.hash.replace('#', '');
    if (
      hash === 'satis' ||
      hash === 'insan-kaynaklari' ||
      hash === 'muhasebe' ||
      hash === 'envanter' ||
      hash === 'bilgi-teknolojileri'
    ) {
      setActiveModule(hash);
      // Sayfayı yukarı kaydır
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      // Hash yoksa varsayılan olarak satış göster
      setActiveModule('satis');
    }
  }, [location.hash]);

  return (
    <>
      <Helmet>
        <title>Modüller - FlowSky CRM</title>
        <meta 
          name="description" 
          content="FlowSky CRM'nin güçlü modüllerini keşfedin. Satış, İnsan Kaynakları, Muhasebe, Envanter ve Bilgi Teknolojileri modülleri ile işletmenizi büyütün." 
        />
      </Helmet>
      
      <section className="modules-page section">
        <div className="container">
          <ModuleContent activeModule={activeModule} />
        </div>
      </section>
    </>
  );
};

export default FeaturesPage;
